import { envConfig } from 'config';

export const STREAM_API_URL = envConfig.streamLambdaUrl;

const streamApi = ({ url, ...args }) => {
  const returnObj = {
    ...args,
    url: `${STREAM_API_URL}${url}`,
    responseHandler: async (response) => {
      const reader = response.body.getReader();
      let done, value;
      while (!done) {
        ({ value, done } = await reader.read());
        args.onStream(new TextDecoder('utf-8').decode(value));
      }
    }
  };
  return returnObj;
};

export default streamApi;
